export const FREE_TEXT_CONTENT_PLACEHOLDER = 'Contenu du texte libre';
